import {BrowserRouter as Router} from "react-router";

export const DAMSBrowserRouter = ({children}) => {
    return (
        <Router future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
        }}>
            {children}
        </Router>
    );
};